__turbopack_context__.v({
  "accountActions": "login-module-scss-module__AsJ0na__accountActions",
  "appLogo": "login-module-scss-module__AsJ0na__appLogo",
  "appName": "login-module-scss-module__AsJ0na__appName",
  "externalUrl": "login-module-scss-module__AsJ0na__externalUrl",
  "footer": "login-module-scss-module__AsJ0na__footer",
  "form": "login-module-scss-module__AsJ0na__form",
  "headerLogo": "login-module-scss-module__AsJ0na__headerLogo",
  "login": "login-module-scss-module__AsJ0na__login",
  "loginButton": "login-module-scss-module__AsJ0na__loginButton",
  "spinner": "login-module-scss-module__AsJ0na__spinner",
  "wrapper": "login-module-scss-module__AsJ0na__wrapper",
});
